"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _classnames = _interopRequireDefault(require("classnames"));

var IdeationStatusView = function IdeationStatusView(_ref) {
  var ideationStatus = _ref.ideationStatus;
  return (0, _preact.h)("span", {
    className: (0, _classnames.default)('topic__content-type-pill', 'pill', 'pill--uppercase', 'pill--idea', 'qa-content-type-pill'),
    style: {
      backgroundColor: ideationStatus.bgColor,
      color: ideationStatus.color
    }
  }, ideationStatus.name);
};

var _default = IdeationStatusView;
exports.default = _default;